import { render, staticRenderFns } from "./OfficeEditPage.vue?vue&type=template&id=e6ef6e08&"
import script from "./OfficeEditPage.vue?vue&type=script&lang=ts&"
export * from "./OfficeEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports